<template>
    <div class="modalWrapperHolder">
        <component v-for="modal, index in getModalArray" :key="index" v-if="modal.templateImport" :is="modal.templateImport" class="modalWrapper"></component>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        computed: {
            ...mapGetters([
                'getModalArray',
            ]),
        },
        methods: {
            modalTemplate: function(modal) {
                if (modal.template) {
                    var path = './' + modal.template;
                        return require(`${path}`);
                    try {
                        return require(`${path}`);
                    }
                    catch(e) {
                        console.log('Unable to find a template for this modal window (' + path + ')');
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modalWrapper{
        overflow: auto;
    }
</style>



// WEBPACK FOOTER //
// ModalWrapper.vue?0f7201c3